import { Box, Button, Flex, Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

export const OptionsSlider = styled(Flex).attrs((props) => ({
  flexWrap: { tablet: "wrap" },
  justifyContent: props.modal ? "space-between" : "flex-start",
  overflowX: "scroll",
  overflowY: "hidden",
  ...props,
}))`
  ${({ theme }) => theme.mediaQueries.tablet`
    overflow: auto;
    &:last-child:after {
      display: none;
    }
  `}
`

export const ChoiceOption = styled(Button).attrs((props) => ({
  border: "2px solid transparent",
  lineHeight: "12px",
  textAlign: "center",
  variant: "text",
  ...props.theme.wizardChoice,
  ...props,
}))`
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:focus {
    outline: none;
    border: 2px solid ${(props) => props.theme.colors.selected};
  }

  ${(props) =>
    props.selected &&
    (props.theme.wizardChoice.showCheckmark
      ? `
        position: relative;
        border: 2px solid ${props.theme.colors.selected};
        box-shadow: 2px 4px 10px 0px rgba(0, 0, 0, 0.4);
        background-color: #fff;
        &:after {
          display: block;
          position: absolute;
          content: url(${require("images/icons/checkmark.svg")});
          transform: scale(0.05);
          bottom: -6px;
          left: 50%;
          margin-left: -18px;
          width: 22px;
          height: 22px;
        }
      `
      : `border-color: ${props.theme.colors.text};`)}
`

export const OptionTitle = styled(Typography).attrs((props) => ({
  color: "grey.70",
  fontSize: "12px",
  ...props.theme.wizardChoiceTitle,
  ...props,
}))``

export const OptionPrice = styled(Typography).attrs((props) => ({
  color: "black",
  fontSize: { _: "11px", tablet: "12px" },
  fontWeight: "700",
  letterSpacing: "0.5px",
  ...props.theme.wizardChoicePrice,
  ...props,
}))``

export const OptionsSelect = styled(Box).attrs({
  as: "select",
})`
  width: 75%;
  padding: 0.5em 0.6em;
  background-color: #fff !important;
`

export const ErrorBox = styled(Flex)`
  align-items: center;
  background: #e3352a26;
  border-radius: 5px;
  color: ${(props) => props.theme.colors.sale};
  font-size: 14px;
  margin-bottom: 16px;
  padding: 8px;
`

export const ErrorText = styled(Box).attrs({
  bg: "error",
  color: "white",
})`
  margin-bottom: 10px;
  padding: 5px;
  border-radius: 3px;
`
